export const FESTIVAL_TYPE_OPTIONS = [
  { value: "hindu", label: "Hindu" },
  { value: "jain", label: "Jain" },
] as const;

export type FestivalType = (typeof FESTIVAL_TYPE_OPTIONS)[number]["value"];

export interface Festival {
  id: number;
  name: string;
  type: FestivalType;
  description?: string | null;
  created_at?: string;
  updated_at?: string;
}

export type FestivalPayload = Pick<Festival, "name" | "type" | "description">;
